import OEWidget from "./OEWidget";

export default OEWidget;
